// Throttled client analytics with session persistence.
// Sends to /api/analytics/track and debounces frequent route-mounts.

const KEY_SESSION = 'clairifi_session';
const KEY_LAST    = 'clairifi:lastTrack'; // maps `${event}:${path}` -> epoch ms

function getSessionId() {
  try {
    let sid = localStorage.getItem(KEY_SESSION);
    if (!sid) {
      sid = crypto.randomUUID();
      localStorage.setItem(KEY_SESSION, sid);
    }
    return sid;
  } catch {
    return null;
  }
}

function getLastMap() {
  try {
    return JSON.parse(localStorage.getItem(KEY_LAST) || '{}');
  } catch {
    return {};
  }
}
function setLastMap(map) {
  try { localStorage.setItem(KEY_LAST, JSON.stringify(map || {})); } catch {}
}

async function postJSON(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  });
  // swallow analytics failures
  return res.ok;
}

/**
 * track(event, props)
 * - Debounces 'visit' by (path) for 30s on the client (server also dedups).
 */
export function track(event, props = {}) {
  const session_id = getSessionId();
  const path = (props.path || location.pathname);
  const referrer = props.referrer || document.referrer || null;

  // 30s client-side throttle for page views
  if (event === 'visit') {
    const map = getLastMap();
    const key = `visit:${path}`;
    const now = Date.now();
    if (map[key] && now - map[key] < 30_000) return Promise.resolve(true);
    map[key] = now;
    setLastMap(map);
  }

  return postJSON('/api/analytics/track', {
    event,
    props,
    path,
    referrer,
    session_id,
  }).catch(() => {});
}

// Convenience
export const trackPageView = () => track('visit');
